<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" [resizable]="false"
  appendTo="body">

  <p-header>
    <span>License Activation Wizard</span>
  </p-header>

  <div class="wizard-container">
    @if (page === WelcomePage) {
      <div>
        <p style="margin-top: 30px;">
          This wizard will step you through the process of activating your UVexplorer Server license.
        </p>
        <p style="margin-top: 20px;">
          To continue, click Next.
        </p>
      </div>
    }
    @if (page === CompletionPage) {
      <div>
        <p style="margin-top: 30px;">
          Congratulations!  You have successfully activated your license.
        </p>
        <p style="margin-top: 20px;">
          To close this wizard, click Finish.
        </p>
      </div>
    }
    @if (page === ProductKeyPage) {
      <div>
        <form [formGroup]="productKeyForm" style="margin-top: 30px; margin-bottom: 30px;">
          <div>
            <span class="product-key-label">Product Key:</span>
            <input type="text" pInputText style="width: 400px;" [formControl]="productKeyControl" />
          </div>
        </form>
        <p style="margin-left: 80px; margin-right: 80px; margin-top: 20px;">
          Your product key was emailed to you by UVnetworks when you
          downloaded the product from the UVnetworks web site.
        </p>
        <p style="margin-left: 80px; margin-right: 80px; margin-top: 20px;">
          If you did not download the product from the UVnetworks web
          site, you may click the link below to get a product key (either a
          free trial product key, or a purachased product key).
        </p>
        <p style="margin-left: 80px; margin-right: 80px; margin-top: 20px;">
          <a style="text-decoration: underline;"
          href="https://www.uvexplorer.com/uvxserver" target="_blank">Click here to get a Product Key</a>
        </p>
      </div>
    }
    @if (page === OnlineFailedPage) {
      <div>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px;">
          {{onlineFailedLabel}}
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          If you would like to try again, click the Back button.
        </p>
      </div>
    }
    @if (page === OfflineQueryPage) {
      <div>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px;">
          It appears that this computer is currently not connected to the Internet.
          Therefore, online activation is not possible at this time.
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          You can try again later when this computer is connected to the Internet.
          If you can connect this computer to the Internet, we recommend that you do so
          and retry online activation.
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          If you are unable to connect this computer to the Internet, you can opt to do
          offline activation instead.  Offline activation is a little more work on your part,
          but it's not hard.  To do offline activation, you will need access to a computer
          that is connected to the Internet so you can access our web site.
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          To retry online activation, click the Back button.<br />
          To do offline activation, click the Next button.
        </p>
      </div>
    }
    @if (page === OfflinePage) {
      <div>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px; font-weight: bold;">
          To perform offline activation, follow these steps:
        </p>
        <ol style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          <li><a style="text-decoration: underline;" (click)="onSaveActivationRequest()">Click here</a> to download an Activation Request file.</li>
          <li>Take the Activation Request file to a computer that has Internet access (e.g., using a flash drive).</li>
          <li>In a web browser, go to <a style="text-decoration: underline;" href="https://www.uvexplorer.com/offline-activation" target="_blank">https://www.uvexplorer.com/offline-activation</a>
        and upload the Activation Request file using the web form.</li>
        <li>After activation completes, click the link to download and save the Activation Response file.</li>
        <li>Bring the Activation Response file back to this computer (e.g., using a flash drive).</li>
        <li>Click this button to load the Activation Response file:
          <input type="file" (change)="onLoadActivationResponse($event.target.files[0])" />
        </li>
        <li>Click the Activate button below.</li>
      </ol>
    </div>
  }
  @if (page === OfflineFailedPage) {
    <div>
      <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px;">
        {{offlineFailedLabel}}
      </p>
      <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
        If you would like to try again, click the Back button.
      </p>
    </div>
  }
</div>

<p-footer>
  <button type="button" pButton [disabled]="!enableBack" (click)="onBackClicked()" label="{{backLabel}}"></button>
  <button type="button" pButton [disabled]="!enableNext" (click)="onNextClicked()" label="{{nextLabel}}"></button>
  <button type="button" pButton [disabled]="!enableCancel" (click)="onCancelClicked()" label="{{cancelLabel}}"></button>
</p-footer>

</p-dialog>
